import { Component, OnInit, inject } from "@angular/core";
import { LoginModalComponent } from "@app/components/login-modal/login.modal";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppSettings } from "app/app.settings";

@Component({
   // eslint-disable-next-line @angular-eslint/component-selector
   selector: "modal-login",
   template: `
      <div></div>
   `
})
export class ModalLoginComponent implements OnInit {
   private modalService = inject(NgbModal);
   private appSettings = inject(AppSettings);

   public ngOnInit(): void {
      if (this.appSettings.hostname === "mycloud.telenet.be") {
         return;
      }

      this.openLoginModal();
   }

   private openLoginModal(): void {
      const modalRef = this.modalService.open(LoginModalComponent, {
         ariaLabelledBy: "modal-basic-title",
         backdrop: "static",
         keyboard: false,
         modalDialogClass: "login-modal",
         scrollable: true
      });

      modalRef.result.then(_ => {
         modalRef.dismiss();
         location.href = "";
      });
   }
}
